import  request  from "../utils/utfrequest";
let base64 = require('js-base64').Base64;

//nk/choose/user/login  后台登录
export function Login(data){
    return request({
        method:'POST',
        url:'/nk/choose/user/login',
        data:data
        // headers:{
        //     Authorization:'Basic'+" "+base64.encode("spx-web-client_id:123456")
        // }
    })
} 

//nk/choose/user/list  获取用户列表
export function hqyhlist(data){
    return request({
        method:'POST',
        url:'/nk/choose/user/list',
        data:data
    })
} 

//nk/choose/user/register  用户注册
export function yhzcregister(data){
    return request({
        method:'POST',
        url:'/nk/choose/user/register',
        data:data
    })
} 

//nk/choose/user/updateUser  修改用户信息
export function updateUser(data){
    return request({
        method:'POST',
        url:'/nk/choose/user/updateUser',
        data:data
    })
} 

//nk/choose/user/resetPwd  重置密码
export function czmmresetPwd(data){
    return request({
        method:'POST',
        url:'/nk/choose/user/resetPwd',
        data:data
    })
} 

//nk/choose/user/bindRole  绑定用户和角色的信息
export function bindRole(data){
    return request({
        method:'POST',
        url:'/nk/choose/user/bindRole',
        data:data
    })
} 

//nk/choose/role/page  获取角色列表信息-分页
export function hqjslbfypage(data){
    return request({
        method:'POST',
        url:'/nk/choose/role/page',
        data:data
    })
} 

//nk/choose/role/add  添加角色信息
export function tjjsxxadd(data){
    return request({
        method:'POST',
        url:'/nk/choose/role/add',
        data:data
    })
} 

//nk/choose/role/update  修改角色信息
export function xgjsxxupdate(data){
    return request({
        method:'POST',
        url:'/nk/choose/role/update',
        data:data
    })
} 
//nk/choose/role/addMenuShip  角色赋予菜单权限
export function addMenuShip(data){
    return request({
        method:'POST',
        url:'/nk/choose/role/addMenuShip',
        data:data
    })
} 

//nk/choose/product/specifications/specificationsPage  规格列表页
export function gglbyationsPage(data){
    return request({
        method:'POST',
        url:'/nk/choose/product/specifications/specificationsPage',
        data:data
    })
} 

//nk/choose/product/specifications/operatorSpecificationCate  规格列表页
export function operatorSpe(data){
    return request({
        method:'POST',
        url:'/nk/choose/product/specifications/operatorSpecificationCate',
        data:data
    })
} 

//nk/choose/product/specifications/add  批量添加规格
export function pltjggadd(data){
    return request({
        method:'POST',
        url:'/nk/choose/product/specifications/add',
        data:data
    })
} 

//nk/choose/product/specifications/updateBatchSpecifications  批量更新规格信息
export function updateBatchSpecifications(data){
    return request({
        method:'POST',
        url:'/nk/choose/product/specifications/updateBatchSpecifications',
        data:data
    })
} 

//nk/choose/product/parts/operatorPartsCate  操作配件类型
export function operatorPartsCate(data){
    return request({
        method:'POST',
        url:'/nk/choose/product/parts/operatorPartsCate',
        data:data
    })
} 

//nk/choose/product/parts/queryPartsPage  操作配件类型
export function queryPartsPage(data){
    return request({
        method:'POST',
        url:'/nk/choose/product/parts/queryPartsPage',
        data:data
    })
} 

//nk/choose/product/parts/addParts  添加配件
export function tjpjaddParts(data){
    return request({
        method:'POST',
        url:'/nk/choose/product/parts/addParts',
        data:data
    })
} 

//nk/choose/product/parts/updateParts  更新配件信息
export function updateParts(data){
    return request({
        method:'POST',
        url:'/nk/choose/product/parts/updateParts',
        data:data
    })
} 

//nk/choose/marketing/guidance/queryPage  查询引导语列表
export function ydyqueryPage(data){
    return request({
        method:'POST',
        url:'/nk/choose/marketing/guidance/queryPage',
        data:data
    })
} 

//nk/choose/marketing/guidance/operatorGuidance  操作引导语
export function operatorGuidance(data){
    return request({
        method:'POST',
        url:'/nk/choose/marketing/guidance/operatorGuidance',
        data:data
    })
} 

//nk/choose/marketing/subject/operatorSubject  新增、修改公告
export function operatorSubject(data){
    return request({
        method:'POST',
        url:'/nk/choose/marketing/subject/operatorSubject',
        data:data
    })
} 

//nk/choose/marketing/subject/queryPage  获取公告列表
export function gglbqueryPage(data){
    return request({
        method:'POST',
        url:'/nk/choose/marketing/subject/queryPage',
        data:data
    })
} 

//nk/choose/marketing/poster/queryPage  获取海报列表
export function queryPagelist(data){
    return request({
        method:'POST',
        url:'/nk/choose/marketing/poster/queryPage',
        data:data
    })
} 

//nk/choose/marketing/poster/queryProduct  分页获取产品信息
export function queryProduct(data){
    return request({
        method:'POST',
        url:'/nk/choose/marketing/poster/queryProduct',
        data:data
    })
} 

// 操作海报-新增、修改 /nk/choose/marketing/poster/operatorPoster
export function hbxzxgoperatorPoster(data){
    return request({
        method:'POST',
        url:'/nk/choose/marketing/poster/operatorPoster',
        data:data
    })
}

// 获取产品类别列表 /nk/choose/product/category/queryPage
export function cplbqueryPage(data){
    return request({
        method:'POST',
        url:'/nk/choose/product/category/queryPage',
        data:data
    })
}

// 操作产品类别-新增、修改 /nk/choose/product/category/operatorCate
export function operatorCate(data){
    return request({
        method:'POST',
        url:'/nk/choose/product/category/operatorCate',
        data:data
    })
}
// 下架配件 /nk/choose/product/parts/downParts
export function downParts(data){
    return request({
        method:'POST',
        url:'/nk/choose/product/parts/downParts',
        data:data
    })
}

// 获取轮播图列表 /nk/choose/marketing/carousel/queryPage
export function lbtlbqueryPage(data){
    return request({
        method:'POST',
        url:'/nk/choose/marketing/carousel/queryPage',
        data:data
    })
}
// 查询产品列表 /nk/choose/product/queryPage
export function cxcplbqueryPage(data){
    return request({
        method:'POST',
        url:'/nk/choose/product/queryPage',
        data:data
    })
}

// 生成规格列表 /nk/choose/product/specificationList
export function specificationList(data){
    return request({
        method:'POST',
        url:'/nk/choose/product/specificationList',
        data:data
    })
}

// 添加产品 /nk/choose/product/add
export function tjcplbadd(data){
    return request({
        method:'POST',
        url:'/nk/choose/product/add',
        data:data
    })
}
// 获取产品类别列表-不分页  /nk/choose/product/category/queryList
export function cplbbfyqueryList(data){
    return request({
        method:'POST',
        url:'/nk/choose/product/category/queryList',
        data:data
    })
}

// 绑定配件信息  /nk/choose/product/bindParts
export function bdpjbindParts(data){
    return request({
        method:'POST',
        url:'/nk/choose/product/bindParts',
        data:data
    })
}

// 添加轮播图  /nk/choose/marketing/carousel/AddCarousel
export function AddCarousel(data){
    return request({
        method:'POST',
        url:'/nk/choose/marketing/carousel/AddCarousel',
        data:data
    })
}

// 更新轮播图  /nk/choose/marketing/carousel/updateCarousel
export function updateCarousel(data){
    return request({
        method:'POST',
        url:'/nk/choose/marketing/carousel/updateCarousel',
        data:data
    })
}

// 查询订单列表  /nk/choose/order/queryPage
export function cxddlbqueryPage(data){
    return request({
        method:'POST',
        url:'/nk/choose/order/queryPage',
        data:data
    })
}

// 添加反馈  /nk/choose/order/addFeedback
export function tjfkaddFeedback(data){
    return request({
        method:'POST',
        url:'/nk/choose/order/addFeedback',
        data:data
    })
}

// 启用、关闭轮播图  /nk/choose/marketing/carousel/switchCarousel
export function switchCarousel(data){
    return request({
        method:'POST',
        url:'/nk/choose/marketing/carousel/switchCarousel',
        data:data
    })
}

// 下架产品  /nk/choose/product/downProduct
export function downProduct(data){
    return request({
        method:'POST',
        url:'/nk/choose/product/downProduct',
        data:data
    })
}

// 修改配件绑定信息 /nk/choose/product/modifyProductParts
export function modifyProductParts(data){
    return request({
        method:'POST',
        url:'/nk/choose/product/modifyProductParts',
        data:data
    })
}

// 修改产品信息 //nk/choose/product/modify'
export function xgcpxxmodify(data){
    return request({
        method:'POST',
        url:'/nk/choose/product/modify',
        data:data
    })
}

// 获取下家产品列表 //nk/choose/product/sold/querySoldOutPage
export function querySoldOutPage(data){
    return request({
        method:'POST',
        url:'/nk/choose/product/sold/querySoldOutPage',
        data:data
    })
}

// 批量上架产品 /nk/choose/product/sold/upGoodsBatch
export function plsjupGoodsBatch(data){
    return request({
        method:'POST',
        url:'/nk/choose/product/sold/upGoodsBatch',
        data:data
    })
}
// goodsType为1的时候，走这个接口 更新配件 /nk/choose/product/sold/updateParts
export function gxpjupdateParts(data){
    return request({
        method:'POST',
        url:'/nk/choose/product/sold/updateParts',
        data:data
    })
}

// 下架部分规格产品 //nk/choose/product/downProductVariants
export function downProductVariants(data){
    return request({
        method:'POST',
        url:'/nk/choose/product/downProductVariants',
        data:data
    })
}

// 下架部分规格配件 /nk/choose/product/parts/downProductVariants
export function pjdownProductVariants(data){
    return request({
        method:'POST',
        url:'/nk/choose/product/parts/downProductVariants',
        data:data
    })
}

// 来访记录列表 /nk/choose/visit/queryPage
export function lfjllbqueryPage(data){
    return request({
        method:'POST',
        url:'/nk/choose/visit/queryPage',
        data:data
    })
}

// 查询区域经理列表 /nk/choose/queryPage
export function cxqyjlqueryPage(data){
    return request({
        method:'POST',
        url:'/nk/choose/queryPage',
        data:data
    })
}

// 配置区域经理信息 /nk/choose/addRegional
export function tjquyjaddRegional(data){
    return request({
        method:'POST',
        url:'/nk/choose/addRegional',
        data:data
    })
}

// 更新业务区域 /nk/choose/editRegional
export function editRegional(data){
    return request({
        method:'POST',
        url:'/nk/choose/editRegional',
        data:data
    })
}

// 更新来访记录 /nk/choose/visit/updateStatus
export function gxupdateStatus(data){
    return request({
        method:'POST',
        url:'/nk/choose/visit/updateStatus',
        data:data
    })
}

























































// WEBPACK FOOTER //
// ./src/api/utfprod.js